import { render, staticRenderFns } from "./dynamicItem.vue?vue&type=template&id=2f54089c&scoped=true&"
import script from "./dynamicItem.vue?vue&type=script&lang=js&"
export * from "./dynamicItem.vue?vue&type=script&lang=js&"
import style0 from "./dynamicItem.vue?vue&type=style&index=0&id=2f54089c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54089c",
  null
  
)

export default component.exports